// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__input___hJz6X {
    width: 520px;
    padding: 10px;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
    margin-top: 4vh;
}

.style__input___hJz6X::placeholder {
    color: grey;
}

.style__input___hJz6X:focus {
    outline: none;
    box-shadow: 4px 4px 8px 4px rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/Input/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,8CAA8C;IAC9C,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD","sourcesContent":[".input {\n    width: 520px;\n    padding: 10px;\n    font-size: 16px;\n    border: none;\n    border-radius: 8px;\n    background-color: #fff;\n    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.1);\n    transition: box-shadow 0.3s ease;\n    margin-top: 4vh;\n}\n\n.input::placeholder {\n    color: grey;\n}\n\n.input:focus {\n    outline: none;\n    box-shadow: 4px 4px 8px 4px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `style__input___hJz6X`
};
export default ___CSS_LOADER_EXPORT___;
